export const main_options = {
   name: "values_type",
   label: "Wybierz, czy chcesz zestawić ze sobą poszczególne lata, czy wolisz sprawdzić zmianę procentową w czasie.",
   options: [
      { value: "raw", label: "Porównanie lat" },
      { value: "dynamics_change", label: "Zmiana w czasie" }
   ]
}

export const secondary_options = {
   name: "years",
   label: <> Wybierz <strong>przynajmniej jeden rok</strong>. Zaznacz więcej, aby porównać je na wykresie. </>
}

export const range_selects = [
   {
      name: "base_year",
      placeholder: "Wybierz rok",
      label: <> Wybierz <strong>rok badany</strong></>
   },
   {
      name: "compare_year",
      placeholder: "Wybierz rok",
      label: <> Porównaj z <strong>rokiem</strong></>
   }
]

